// Marketing analytics: Meta (Facebook) Pixel + Google Analytics (gtag).
// Both stay dormant until you paste the IDs into frontend/.env:
//   REACT_APP_META_PIXEL_ID=xxxxxxxxxxxxxxx
//   REACT_APP_GA_ID=G-XXXXXXXXXX
// No ID = no tracking code loads, so nothing breaks before your accounts are ready.

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const GA_ID = process.env.REACT_APP_GA_ID;
const CLARITY_ID = process.env.REACT_APP_CLARITY_ID;
const SC_PROJECT = process.env.REACT_APP_STATCOUNTER_PROJECT;
const SC_SECURITY = process.env.REACT_APP_STATCOUNTER_SECURITY;

let started = false;

export function initAnalytics() {
  if (started || typeof window === "undefined") return;
  started = true;

  // ---- Meta (Facebook) Pixel ----
  if (PIXEL_ID) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");
  }

  // ---- Google Analytics (gtag) ----
  if (GA_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID);
  }

  // ---- Microsoft Clarity (session recordings + heatmaps) ----
  if (CLARITY_ID) {
    /* eslint-disable */
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", CLARITY_ID);
    /* eslint-enable */
  }

  // ---- StatCounter ----
  if (SC_PROJECT && SC_SECURITY) {
    window.sc_project = Number(SC_PROJECT);
    window.sc_invisible = 1;
    window.sc_security = SC_SECURITY;
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = "https://www.statcounter.com/counter/counter.js";
    document.body.appendChild(s);
  }
}

// Fire a conversion / custom event to whichever pixels are active.
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  if (window.fbq) window.fbq("track", name, params);
  if (window.gtag) window.gtag("event", name, params);
}

// Convenience: signup completed.
export function trackSignup(params = {}) {
  trackEvent("CompleteRegistration", params);
}

// Convenience: free trial started (fires on successful signup — trial begins immediately).
// value/currency let Meta optimise ad delivery toward people likely to start a trial.
export function trackTrialStart(params = {}) {
  trackEvent("StartTrial", { value: 6.49, currency: "USD", ...params });
}
